import { Control } from "react-hook-form";
import { FormField } from "./ui/form";

type Props = {
  label: string | React.ReactNode;
  name: string;
  control?: Control<any> | undefined;
};

const CheckboxItem = ({ label, control, name }: Props) => {
  return (
    <FormField
      name={name}
      control={control}
      render={({ field }) => (
        <div>
          <label className="label cursor-pointer flex-row-reverse justify-end gap-x-2">
            <span className="label-text flex items-center gap-1">{label}</span>
            <input
              checked={field.value}
              onChange={field.onChange}
              type="checkbox"
              className="checkbox [--chkbg:theme(colors.green.main)]"
            />
          </label>
        </div>
      )}
    />
  );
};

export default CheckboxItem;
